export default __webpack_public_path__ + "static/media/setzling.75558739.png";